import { useState, useEffect, Activity } from 'react';
import isEqual from 'lodash.isequal';
import { TableFilterTypes } from './types';

// components
import IconFilterCircle from '../icons/filter-circle';

import ClickOutsideDetector from '../autocomplete/click-outside-detector';
import usePrevious from '../../hooks/use-previous';

// styles
import styles from './table-filter.module.css';

export default function TableFilter({
  children,
  column,
  isActive,
  filters,
  withOverflow,
  withDateOverflow,
}: TableFilterTypes): React.JSX.Element {
  const [isVisible, setIsVisible] = useState(false);

  const prevFilters = usePrevious(filters);

  useEffect(() => {
    if (!isEqual(filters, prevFilters)) {
      setIsVisible(false);
    }
  }, [prevFilters, filters]);

  return (
    <span className={styles.tableHeadCellFilter}>
      <ClickOutsideDetector setOptionsListVisible={setIsVisible}>
        <>
          <button
            type="button"
            className={`${styles.tableFilterButton} ${
              isVisible ? styles.visible : ''
            } ${isActive ? styles.active : ''}`}
            onClick={() => setIsVisible(!isVisible)}
            tabIndex={-1}
            aria-label="Filter Button"
          >
            <IconFilterCircle />
          </button>
          <Activity mode={isVisible ? 'visible' : 'hidden'}>
            <div
              className={`${styles.tableFilterModal} ${
                column?.withTimeSelector ? styles.withoutPadding : ''
              } ${isVisible ? styles.visible : ''} ${
                column?.filterModalPlacement === 'right'
                  ? styles.reversedHorizontal
                  : ''
              } ${withOverflow ? styles.withOverflow : ''} ${
                withDateOverflow ? styles.withDateOverflow : ''
              }`}
            >
              {children}
            </div>
          </Activity>
        </>
      </ClickOutsideDetector>
    </span>
  );
}
